<template>
  <span class="x-caret-wrapper">
    <i class="sort-caret ascending" :class="{ selected: curDirection === 1}" title="升序" @click="curDirection = 1"></i>
    <i class="sort-caret descending" :class="{ selected: curDirection === 2}" title="降序" @click="curDirection = 2"></i>
  </span>
</template>
<script>
export default {
  props: {
    col: {
      type: String,
      required: true
    },
    direction: {
      type: Number,
      default () {
        return undefined
      }
    }
  },
  data () {
    return {
      curDirection: this.direction
    }
  },
  watch: {
    curDirection: {
      immediate: false,
      handler (newVal) {
        this.$emit('change', {
          col: this.col,
          direct: newVal
        })
      }
    }
  }
}
</script>
<style>
.x-caret-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  vertical-align: middle;
  cursor: pointer;
  position: relative;
  width: 24px;
  height: 24px;
}

.x-caret-wrapper .sort-caret{
  width: 0;
  height: 0;
  border: 5px solid transparent;
  position: absolute;
  left: 7px;
}

.x-caret-wrapper .sort-caret.ascending {
  border-bottom-color: #C0C4CC;
  top: 0px;
}

.x-caret-wrapper .sort-caret.ascending.selected {
  border-bottom-color: #409EFF;
}

.x-caret-wrapper .sort-caret.descending {
  border-top-color: #C0C4CC;
  bottom: 2px;
}

.x-caret-wrapper .sort-caret.descending.selected {
  border-top-color: #409EFF;
}
</style>
